<template>
  <div class="appCategory">
    <div
      v-if="appListData && appListData.length > 0"
    >
      <div
        class="appCategoryItem"
        v-for="(item, index) in appListData"
        :key="index"
      >
        <template v-if="item.data && item.data.length > 0">
          <div class="appTitle" v-if="solutionsKeyValueRelation[item.key]">
            <span>{{ $t(solutionsKeyValueRelation[item.key]) }}</span>
            <span class="showAll" @click="showAppAll(item.key)">{{
              item.key == "listProduct" ||
              item.key == "sponsoredSolutions" ||
              item.key == "moreAuthInfo"
                ? ""
                : $t("label.appmarket.viewall")
            }}</span>
          </div>
          <div class="apps">
            <div
              v-for="ele in item.data"
              :key="ele.id"
              class="appN"
              @click="buyNowToDetail(ele)"
            >
              <div class="app1">
                <div class="app-header">
                  <div class="app1Img">
                    <img :src="viewImg(ele.logo)" alt="" />
                  </div>
                  <div class="header-info">
                    <div class="app1Name text-ellipsis">
                      {{ ele.name }}
                    </div>
                    <div class="developerName">
                      {{ $t("appdetail.provided.by", [ele.developer]) }}
                    </div>
                    <div class="app1Rate">
                      <el-rate :value="4.5" disabled show-score></el-rate>
                    </div>
                  </div>
                </div>

                <div class="summary">{{ stripStyles(ele.description) }}</div>
                <div class="tags-container">
                  <template v-for="type in ele.industry.split(';')">
                    <el-tag v-if="industryOptionNew2[type]" :key="type">
                      {{ $t(industryOptionNew2[type]) }}
                    </el-tag>
                  </template>
                </div>
              </div>
            </div>
          </div>
          <div
            class="showMore"
            v-if="item.key == 'listProduct' && hasMore"
            @click="$emit('view-more')"
          >
            {{ $t("applist.view.more") }}
          </div>
        </template>
        <el-empty
          v-else
          :description="$t('message.no.matches.found')"
          :image-size="200"
        ></el-empty>
      </div>
    </div>
    <el-empty v-else :image-size="200"></el-empty>
  </div>
</template>

<script>
import { solutionsOption, industryOptionNew2 } from "@/utils/resource.js";
export default {
  name: "AppList",
  props: {
    appListData: {
      type: Array,
      required: true,
    },
    hasMore: {
      type: Boolean,
      default: true,
    },
    appColumnCount: {
      type: Number,
      default: 3,
    },
    // 是否显示标题：所有结果
    allResults: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      industryOptionNew2,
      solutionsKeyValueRelation: {
        // ...solutionsOption,
        ...industryOptionNew2,
        listProduct: "", //  为了统一group分组接口与分页查询接口返回的数据格式    ( 分页查询不展示标题)
        sponsoredSolutions: this.$t("applist.sponsored.solutions"), //推荐行业方案
        todayTrends: this.$t("applist.today.trends"), //最新行业方案
        moreAuthInfo: "", //更多此供应商的应用
      },
    };
  },
  watch: {
    allResults: {
      handler(nval, oval) {
        if (nval) {
          this.solutionsKeyValueRelation['listProduct'] = this.$t("applist.all.results")
        } else {
          this.solutionsKeyValueRelation['listProduct'] = ""
        }
      }
    }
  },
  methods: {
    // 去掉HTML标签、样式和换行，只保留纯文本内容
    stripStyles(html) {
      if (!html) return "";
      // 创建一个临时div元素来解析HTML
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = html;

      // 获取纯文本内容，去掉所有HTML标签
      let textContent = tempDiv.textContent || tempDiv.innerText || "";

      // 去掉换行符、制表符和多余的空格
      textContent = textContent
        .replace(/[\r\n\t]/g, " ")
        .replace(/\s+/g, " ")
        .trim();

      return textContent;
    },
    // 获取图片
    viewImg(id) {
      let imgUrl = `${window.Glod["ccex-api-svc"]}/api/mallFile/viewImg?id=${id}`;
      return imgUrl;
    },
    buyNowToDetail(val) {
      this.$router.push({
        name: "AppDetail",
        params: {
          productId: val.id,
        },
      });
    },
    showAppAll(key) {
      if (key === "todayTrends") {
        this.$router.push({
          name: "AllApps",
        });
        return;
      }

      // 判断key的类型：如果是数字字符串，说明是行业key，发送selectIndustry事件
      // 如果是中文字符串，说明是解决方案key，发送showAppAll事件
      if (/^\d+$/.test(key)) {
        // 数字字符串，代表行业
        this.$bus.$emit("selectIndustry", key);
      } else {
        // 中文字符串，代表解决方案
        this.$bus.$emit("showAppAll", key);
      }

      // 页面回到顶部
      this.$nextTick(() => {
        const container = document.querySelector('.main-content')
        if (container) {
          if (typeof container.scrollTo === 'function') {
            container.scrollTo({ top: 0, left: 0 })
          } else {
            container.scrollTop = 0
            container.scrollLeft = 0
          }
        }
      })
    },
  },
};
</script>

<style lang="scss" scoped>
.appCategory {
  min-height: 400px;

  // 添加响应式设计
  @media screen and (max-width: 768px) {
    min-height: auto;
    padding: 0 8px;
  }

  .appCategoryItem {
    .appTitle {
      padding: 20px 0;
      display: flex;
      align-items: center;
      justify-content: space-between;

      @media screen and (max-width: 768px) {
        padding: 12px 0;
      }

      span {
        color: #0e2a5e;
        font-size: 24px;
        font-weight: bold;

        @media screen and (max-width: 768px) {
          font-size: 20px;
        }

        @media screen and (max-width: 480px) {
          font-size: 18px;
        }
      }
      .showAll {
        padding: 6px;
        background: #ffffff;
        color: #0e2a5e;
        font-size: 16px;
        cursor: pointer;

        @media screen and (max-width: 480px) {
          font-size: 14px;
          padding: 4px;
        }
      }
    }
    .apps {
      display: flex;
      flex-wrap: wrap;
      padding: 16px;
      justify-content: flex-start;
      overflow: hidden;
      gap: 20px;

      .appN {
        cursor: pointer;
        background: #fff;
        border-radius: 12px;
        border: 1px solid #eee;
        box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.1);
        padding: 22px 22px;
        box-sizing: border-box;
        transition: all 0.3s ease;
        flex: 1 1 calc((100% - 40px) / v-bind(appColumnCount));
        min-width: 280px;
        max-width: calc((100% - 40px) / v-bind(appColumnCount));

        &:hover {
          box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
          transform: translateY(-3px);
        }

        .app1 {
          // display: flex;
          // flex-direction: column;
          font-size: 12px;

          .app-header {
            // display: flex;
            // align-items: center;
            // justify-content: center;

            .app1Img {
              height: 72px;
              width: 100%;
              img {
                height: 100%;
                max-width: 100%;
                object-fit: contain;
                object-position: left;
              }
            }

            .header-info {
              // flex: 1;
              // padding-left: 16px;
              // overflow: hidden;

              .app1Name {
                color: #0e2a5e;
                font-size: 16px;
                font-weight: bold;
                line-height: 24px;
              }

              .developerName {
                color: #343434;
                font-size: 14px;
                font-weight: normal;
                line-height: 22px;
              }

              .app1Rate {
                // height: 35px;
                display: flex;
                align-items: center;
                // margin-top: 4px;
                ::v-deep .el-rate__icon {
                  margin: 0;
                  font-size: 10px;
                }
                ::v-deep .el-rate {
                  height: auto;
                  line-height: 0;
                }
                ::v-deep .el-rate__icon {
                  font-size: 18px;
                }
                .pjf {
                  margin-left: 16px;
                  color: #0e2a5e;
                  font-size: 12px;
                  font-weight: bold;
                }
                .review-count {
                  margin-left: 8px;
                  color: #0e2a5e;
                  font-size: 12px;
                }
              }
            }
          }

          .summary {
            color: #000;
            font-size: 12px;
            font-weight: 400;
            line-height: 20px;
            height: 60px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            line-clamp: 3;
            margin-bottom: 8px;
            margin-top: 16px;
          }
          .tags-container {
            display: flex;
            overflow-x: auto;
            overflow-y: hidden;
            scrollbar-width: none; /* Firefox */
            -ms-overflow-style: none; /* IE 10+ */
            &::-webkit-scrollbar {
              display: none; /* WebKit */
            }
          }
          .el-tag {
            margin: 4px 4px 4px 0px;
            white-space: nowrap;
            flex-shrink: 0;
          }
        }
      }

      // 添加响应式设计
      @media screen and (max-width: 768px) {
        .appN {
          flex: 1 1 100%;
          max-width: 100%;
          min-width: auto;
          margin: 0 0 16px 0;
        }
      }

      @media screen and (max-width: 480px) {
        padding: 8px;
        gap: 16px;

        .appN {
          padding: 16px;
        }
      }
    }
  }
  .showMore {
    text-align: center;
    margin-top: 16px;
    color: #0e2a5e;
    font-size: 16px;
    font-weight: bold;
    cursor: pointer;
  }
}

.text-ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
